import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  IPgMediaDialog,
  MediaDialogComponent
} from '@element451-libs/page451-lib';
import { mapToPayload } from '@element451-libs/utils451/rxjs';
import { VideoPreviewService } from '@element451-libs/utils451/video';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import * as actions from './media.actions';
import { MEDIA_ACTIONS } from './media.actions';

/**
 * TODO: (performance optimization) move this into a module that is going to be lazy loaded on homepage only
 * That way we will move page451 components bundle to homepage, currently it is loaded
 * with core code because it is in store module
 */
@Injectable()
export class MediaEffects {
  constructor(
    private actions$: Actions,
    private video: VideoPreviewService,
    private dialog: MatDialog
  ) {}

  playVideo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<actions.PlayVideoAction>(MEDIA_ACTIONS.PLAY_VIDEO),
        mapToPayload,
        switchMap(url => this.video.getVideoIframe(url)),
        switchMap(videoEmbedCode => this.openMediaDialog({ videoEmbedCode }))
      ),
    { dispatch: false }
  );

  openImage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<actions.OpenImageAction>(MEDIA_ACTIONS.OPEN_IMAGE),
        mapToPayload,
        switchMap(imageUrl => this.openMediaDialog({ imageUrl }))
      ),
    { dispatch: false }
  );

  openMediaDialog(data: IPgMediaDialog) {
    return this.dialog
      .open(MediaDialogComponent, {
        data,
        panelClass: ['elm-pg-dialog-pane', 'elm-pg-media-dialog-pane']
      })
      .afterClosed();
  }
}
